import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filterI } from 'app/core/interfaces/filter';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Encounter } from 'app/core/interfaces/encounter';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'page-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent extends BaseComponent implements OnInit {
  public title = 'Agenda';
  public healthcareservicesname: Healthcareservice[] = [];
  public practitioners: any[] = [];
  public citys: filterI[] = [];
  public resultado: practitionerI[] = [];
  public form: FormGroup;
  public notFoundMessage = 'Não existe dados para o filtro selecionado';

  public encounters: Encounter[] = [];

  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    private encounterService: EncounterService,
    private affiliationOrganizationPractitioner: PractitionerOrganizationAffiliationService,
    private healthcareService: ProcedureService
  ) {
    super(injector);

    this.form = this.fb.group({
      city: ['', Validators.nullValidator],
      healthcareservice: ['', Validators.nullValidator],
      practitioner_id: ['', Validators.nullValidator],
    });
  }

  ngOnInit(): void {
    this.getPractitioner();
    this.getHealthcareServices();
    this.getEncounters();
  }

  pesquisar() {
    const formValues = this.form.value;

    this.getEncounterByFilters();
  }

  getHealthcareServices() {
    const organization_id = this.currentUser?.user?.id;

    this.healthcareService.listByOrganizations(organization_id).subscribe({
      next: (healthcareservices: Healthcareservice[]) => {
        this.healthcareservicesname = healthcareservices ?? [];
      },
      error: (err) => {
        console.log('Falha ao buscar Healthcare', err);
      },
    });
  }

  getPractitioner() {
    const organization_id = this.currentUser?.user?.id;

    this.affiliationOrganizationPractitioner.show(organization_id).subscribe({
      next: (resPractitioner: any) => {
        this.practitioners = resPractitioner
          .map((affiliation: any) => {
            return {
              name: affiliation.request.display,
              practitioner_id: affiliation.request.id,
              specialty: affiliation.specialty,
            };
          })
          .filter((practitionerAffiliation: any) => {
            return practitionerAffiliation.specialty.some((specialty: any) => {
              return specialty.status === 'accepted';
            });
          });
      },
      error: (err) => {
        console.log('Falha ao listar especialista', err);
      },
    });
  }

  getEncounterByFilters() {
    const formValues = this.form.value;
    let params = new HttpParams();
    const organization_id = this.currentUser?.user?.id;

    params = params.set('organization_id', organization_id);

    if (formValues.practitioner_id) {
      params = params.set('practitioner_id', formValues.practitioner_id);
    }

    if (formValues.healthcareservice) {
      params = params.set('name', formValues.healthcareservice);
    }

    this.encounters = [];

    this.encounterService.list(params).subscribe({
      next: (encounters: Encounter[]) => {
        this.encounters = encounters;
      },
      error: (err) => {
        console.log('error buscar encounter', err);
      },
    });
  }

  getEncountersByPractitionerHealthcareservice() {
    const formValues = this.form.value;
    const id = formValues.practitioner_id;

    this.encounterService.listByPractitionerNew(id).subscribe({
      next: (encounters: Encounter[]) => {
        this.encounters = encounters;
      },
      error: (err) => {
        console.log('error buscar encounter', err);
      },
    });
  }

  getEncountersByPractitioner() {
    const formValues = this.form.value;
    const id = formValues.practitioner_id;

    this.encounterService.listByPractitionerNew(id).subscribe({
      next: (encounters: Encounter[]) => {
        this.encounters = encounters;
      },
      error: (err) => {
        console.log('error buscar encounter', err);
      },
    });
  }

  getEncounters() {
    const organization_id = this.currentUser?.user?.id;

    this.encounterService.listByOrganizationNew(organization_id).subscribe({
      next: (encounters: Encounter[]) => {
        this.encounters = encounters ?? [];
      },
      error: (err) => {
        console.log('error buscar encounter', err);
      },
    });
  }
}
